(() => {
  const initVideoWrapper = (wrapper) => {
    if (wrapper.dataset.videoInitialised) return;
    wrapper.dataset.videoInitialised = 'true';

    const video = wrapper.querySelector('video');
    const fallback = wrapper.querySelector('.slideshow-video-fallback');
    const playBtn = wrapper.querySelector('.video-play-toggle');
    const soundBtn = wrapper.querySelector('.video-sound-toggle');
    const iconBtn = wrapper.querySelector('.slideshow-video-play-pause');

    if (!video) return;

    const desktopSrc =
      wrapper.dataset.desktopVideoSrc ||
      (video.querySelector('source') && video.querySelector('source').getAttribute('src')) ||
      null;
    const mobileSrc = wrapper.dataset.mobileVideoSrc || null;

    const setVideoSource = () => {
      if (!desktopSrc) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const chosen = isMobile && mobileSrc ? mobileSrc : desktopSrc;
      const srcEl = video.querySelector('source');
      if (srcEl && srcEl.getAttribute('src') !== chosen) {
        const wasPlaying = !video.paused && !video.ended;
        srcEl.setAttribute('src', chosen);
        try {
          video.load();
          if (wasPlaying) video.play();
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          // ignore load/play errors
        }
      }
    };

    const tryAutoplay = () => {
      if (!video.autoplay) return;
      video.load();
      video.play().catch(() => {
        // autoplay blocked by browser
      });
    };

    setVideoSource();
    tryAutoplay();

    try {
      const mq = window.matchMedia('(max-width: 749px)');
      if (mq.addEventListener) mq.addEventListener('change', setVideoSource);
      else if (mq.addListener) mq.addListener(setVideoSource);
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // ignore matchMedia errors
    }

    if (fallback) {
      const showFallback = () => {
        video.style.display = 'none';
        fallback.style.zIndex = '1';
      };
      video.addEventListener('error', showFallback);
      video.addEventListener('stalled', showFallback);
    }

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.textContent = 'Pause';
        } else {
          video.pause();
          playBtn.textContent = 'Play';
        }
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        soundBtn.textContent = video.muted ? 'Sound On' : 'Sound Off';
      });
    }

    if (iconBtn) {
      const iconPlay = iconBtn.querySelector('.icon-play');
      const iconPause = iconBtn.querySelector('.icon-pause');

      const syncIcons = () => {
        const paused = video.paused;
        if (iconPlay) iconPlay.style.display = paused ? '' : 'none';
        if (iconPause) iconPause.style.display = paused ? 'none' : '';
        iconBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };

      iconBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.paused ? video.play() : video.pause();
      });

      video.addEventListener('play', syncIcons);
      video.addEventListener('pause', syncIcons);
      syncIcons();
    }

    const muteBtn = wrapper.querySelector('.slideshow-video-mute-unmute');

    if (muteBtn) {
      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.querySelector('.icon-unmute').style.display = video.muted ? 'none' : '';
        muteBtn.querySelector('.icon-mute').style.display = video.muted ? '' : 'none';
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      muteBtn.querySelector('.icon-unmute').style.display = video.muted ? 'none' : '';
      muteBtn.querySelector('.icon-mute').style.display = video.muted ? '' : 'none';
    }
  };

  const init = () => {
    document.querySelectorAll('.slideshow-video-wrapper').forEach(initVideoWrapper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
